import globals from "./globals";
import $ from "cash-dom";
import { draggableSlider } from "Utilities";

const layout = (function () {
    /**
     * Initialize Draggable instances
     */
    $(document).ready(function () {
        if ($(".layout-draggable").length) {
            if (globals.debug) console.log("layout-draggable-slider initialized");

            function lockScroll() {
                document.documentElement.style.cssText += "position: absolute; inset: 0; overflow: hidden;";
            }
            function unlockScroll() {
                document.documentElement.style.cssText -= "position: absolute; inset: 0; overflow: hidden;";
            }
            function moveHandle(_e) {
                _e.preventDefault();

                var parent = $(_e.target).parents(".draggable");
                var handle = parent.find('button[data-action="drag"]');
                var x;

                x = _e.type == "mousemove" ? _e.clientX : _e.touches[0].clientX;
                x = x - parent[0].getBoundingClientRect().left;
                x = (x / parent[0].offsetWidth) * 100;
                x = Math.min(Math.max(x, 0), 100);

                handle[0].style.left = `${x}%`;
                handle[0].previousElementSibling.style.clipPath = `inset(0 0 0 ${x}%)`;
            }

            function moveHandleKeyboard(_e) {
                _e.preventDefault();
                var parent = $(_e.target).parents(".draggable");
                var handle = parent.find('button[data-action="drag"]');
                var x;
                var inc = 5;

                x = parseFloat(handle[0].style.left);

                switch (_e.which) {
                    // Left
                    case 37:
                        x -= inc;
                        break;
                    // Right
                    case 39:
                        x += inc;
                        break;
                }

                x = Math.min(Math.max(x, 0), 100);

                handle[0].style.left = `${x}%`;
                handle[0].previousElementSibling.style.clipPath = `inset(0 0 0 ${x}%)`;
            }

            function resetHandle() {
                $('button[data-action="drag"]').each(function () {
                    var defaultPos = $(this).attr("data-default-position");
                    $(this)[0].style.left = `${defaultPos}%`;
                    $(this)[0].previousElementSibling.style.clipPath = `inset(0 0 0 ${defaultPos}%)`;
                });
            }

            resetHandle();

            $('button[data-action="drag"]').on("mousedown", function () {
                lockScroll();
                window.addEventListener("mousemove", moveHandle);
            });

            window.addEventListener("mouseup", function () {
                unlockScroll();
                window.removeEventListener("mousemove", moveHandle);
            });

            $('button[data-action="drag"]').on(
                "touchstart",
                function () {
                    lockScroll();
                    window.addEventListener("touchmove", moveHandle);
                },
                { passive: true }
            );

            window.addEventListener(
                "touchend",
                function () {
                    unlockScroll();
                    window.removeEventListener("touchmove", moveHandle);
                },
                { passive: true }
            );

            window.addEventListener("dblclick", resetHandle);

            $("body").on("keyup", 'button[data-action="drag"].tab-focus', moveHandleKeyboard);
        }
    });
})();

export default layout;
